// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { Injectable } from '@angular/core';
import { HceBedParserService } from '../hce-bed-parser/hce-bed-parser.service';
import { HceVcfParserService } from '../hce-vcf-parser/hce-vcf-parser.service';
import { ChromosomeUtil } from '../../utils';
import { HceSvColorList } from '../../../../../interfaces/hce/hce-sv-colors'

@Injectable({ providedIn: 'root' })
export class HceAnnotationParserService {
  constructor(
    private bed: HceBedParserService,
    private vcf: HceVcfParserService,
  ) {}

  parse(filename: string, text: string, mappedRefNameTable: Record<string, string>) {
    const ext = filename?.split('.')?.pop()?.toLowerCase();
    const data = ext === 'vcf' ? this.vcf.parse(text)
               : ext === 'bed' ? this.bed.parse(text)
               : [];
    if (data.length === 0) {
      return [];
    }
    return data
      .sort((a, b) => a.start - b.start)
      .map((v: any, i: number) => ({
        ...v,
        num: i + 1,
        mappedRefName: v.noOfChr ? mappedRefNameTable[v.noOfChr] ?? '' : '',
        noOfChr: v.noOfChr ? ChromosomeUtil.toName(v.noOfChr) : '',
        geneNameOrg: [],
        sample: filename,
        fRecIndex: i,
        color: v.color ?? this.toColor(v.type),
      }));
  }

  private toColor(type: unknown): string {
    const colors = HceSvColorList as Record<string, string>;
    const types = Array.isArray(type) ? type : [type];
    return (
      types.map(type => colors[type]).find(Boolean)
      ?? HceSvColorList.Other
    );
  }
}
